import { Suggestions, Suggestion } from 'use-places-autocomplete'
import styles from './index.module.scss'
import { cn } from '@/lib/utils'

type SuggestionsProps = {
  onSelect: (suggestion: Suggestion) => void
  suggestions: Suggestions
  // For customization
  suggestionContainerClassName?: string
  suggestionItemClassName?: string
  isSuggestionAbsolute?: boolean
}

const AutoCompleteSuggestions: React.FC<SuggestionsProps> = ({
  onSelect,
  suggestions,
  suggestionContainerClassName = '',
  suggestionItemClassName = '',
  isSuggestionAbsolute = true,
}) => {
  const { data, status } = suggestions

  if (status === 'OK') {
    return (
      <ul
        data-testid="suggestions-container"
        className={cn(
          'bg-white list-unstyled',
          isSuggestionAbsolute && 'position-absolute top-6 left-0 right-0',
          suggestionContainerClassName
        )}
      >
        {data.map((suggestion) => {
          const {
            place_id,
            structured_formatting: {
              main_text,
              secondary_text,
              main_text_matched_substrings,
            },
          } = suggestion
          const matchLength = main_text_matched_substrings?.[0]?.length
          const matchOffset = main_text_matched_substrings?.[0]?.offset
          const matchFound = !!matchLength

          return (
            <li
              key={place_id}
              className={cn(
                suggestionItemClassName,
                styles.search_result_links,
                'c-pointer px-4 py-4'
              )}
            >
              <button
                className={cn(styles.button_link, 'btn btn-link px-0 py-0')}
                onClick={() => onSelect(suggestion)}
              >
                {matchFound ? (
                  <>
                    <strong className="~font-semibold">
                      {main_text.slice(matchOffset, matchLength)}
                    </strong>
                    <span className={styles.location_suggestion}>
                      {main_text.slice(matchLength, main_text.length)}
                    </span>
                  </>
                ) : (
                  <strong className="~font-semibold">{main_text}</strong>
                )}
                {!!secondary_text && `, ${secondary_text}`}
              </button>
            </li>
          )
        })}
      </ul>
    )
  }

  return null
}

export default AutoCompleteSuggestions
